(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["natupack-homepage"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* ---------- Rail nav ---------- */
  var rail = document.querySelector('[data-rail]');
  if(rail){
    var prev = document.querySelector('.rail-prev');
    var next = document.querySelector('.rail-next');
    var step = function(){ return rail.clientWidth * 0.9; };
    if(prev){
      prev.addEventListener('click', function(){
        rail.scrollBy({left: -step(), behavior: 'smooth'});
      });
    }
    if(next){
      next.addEventListener('click', function(){
        rail.scrollBy({left: step(), behavior: 'smooth'});
      });
    }
  }

  /* ---------- Trust marquee ---------- */
  var marquee = document.querySelector('[data-marquee]');
  if(marquee){
    var speed = Number(marquee.getAttribute('data-speed')) || 5;
    var track = marquee.querySelector('[data-track]');
    var raf;
    var pos = 0;
    var tick = function(){
      pos -= speed / 30;
      track.style.transform = 'translateX(' + pos + 'px)';
      var firstSetWidth = track.scrollWidth / 2;
      if(Math.abs(pos) >= firstSetWidth){
        pos = 0;
      }
      raf = requestAnimationFrame(tick);
    };
    var pause = function(){ cancelAnimationFrame(raf); };
    var play  = function(){ cancelAnimationFrame(raf); raf = requestAnimationFrame(tick); };
    marquee.addEventListener('mouseenter', pause);
    marquee.addEventListener('mouseleave', play);
    play();
  }

  /* ---------- Quick add naar winkelmand ---------- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-quick-add]');
    if(!btn) return;

    e.preventDefault();

    var variantId = Number(btn.getAttribute('data-variant'));
    var qty       = Number(btn.getAttribute('data-qty') || 1);
    if(!variantId) return;

    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items: [ { id: variantId, quantity: qty } ] })
    })
    .then(function(res){ return res.json(); })
    .then(function(){
      // Simpel: ga naar winkelmand na toevoegen
      window.location.href = '/cart';
    })
    .catch(function(err){
      console.error(err);
      alert('Het lukte niet om dit product aan je winkelmand toe te voegen.');
      btn.disabled = false;
    });
  });

  /* ---------- Vergelijkingsslider ---------- */
  var compare = document.querySelector('[data-compare]');
  if(compare){
    var range = compare.querySelector('[data-compare-range]');
    var afterWrap = compare.querySelector('[data-compare-after]');
    if(range && afterWrap){
      var setWidth = function(val){
        afterWrap.style.width = val + '%';
      };
      setWidth(range.value || 50);
      range.addEventListener('input', function(){
        setWidth(this.value);
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
